
import { z } from "zod";

export const WorkOrderConcessionTypeValues = ["TRAVEL_ADDER", "JOB_SIZE_ADDER"] as const;
export const WorkOrderConcessionTypeSchema = /* @__PURE__ */ z.enum(WorkOrderConcessionTypeValues);
export const WorkOrderConcessionType: (typeof WorkOrderConcessionTypeSchema)["enum"] = { "TRAVEL_ADDER": "TRAVEL_ADDER", "JOB_SIZE_ADDER": "JOB_SIZE_ADDER" };
export type WorkOrderConcessionType = (typeof WorkOrderConcessionTypeValues)[number];
export const WorkOrderConcessionTypeDisplayNames = { "TRAVEL_ADDER": "Travel adder",
"JOB_SIZE_ADDER": "Job size adder", } satisfies Record<WorkOrderConcessionType, string>;
